export default class News {
    static fromData(data) {
        if (!data) {
            return;
        }

        let news = new News();
        news.id = data.id;
        news.title = data.title;
        news.teaser = data.teaser;
        news.text = data.text;
        news.image = data.image;
        news.groups = data.groups;
        news.published = data.published;
        news.publishedAt = data.publishedAt;
        news.publishedEnd = data.publishedEnd;
        news.translations = data.translations;
        news.hasWriteAccess = data.hasWriteAccess;
        news.clearing = data.clearing;
        news.topNews = data.topNews;

        return news;
    }

    isNotYetPublished() {
        return this.published === false && this.publishedAt !== null && new Date(this.publishedAt) >= new Date();
    }
}
